export default {"src":"/pro/_next/static/media/near.81e38bf7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};